import classNames from 'classnames';

import Divider from '@classify/react-core-components/Divider';
import Skeleton from '@classify/react-core-components/Skeleton';

import { makeStyles } from '@mui/styles';

import { Card } from '../../../cards';

/* istanbul ignore next */
const useStyles = makeStyles(
  ({ spacing, breakpoints, shadows, palette }) => ({
    root: {
      [breakpoints.up('md')]: {
        minWidth: 300,
        maxWidth: 368,
      },
    },
    cardContent: {
      width: '100%',
      padding: '0 !important',
      boxShadow: shadows[2],
    },
    cardContentWithBorder: {
      borderLeftWidth: 8,
      borderLeftStyle: 'solid',
      borderLeftColor: palette.skeleton.text,
      [breakpoints.up('sm')]: {
        border: 'none !important',
      },
    },
    illustrationTopContent: {
      display: 'flex',
      flexDirection: 'column',
      [breakpoints.up('sm')]: {
        flexDirection: 'row',
      },
      [breakpoints.up('md')]: {
        flexDirection: 'column',
      },
    },
    illustrationContainer: {
      display: 'block',
      width: '100%',
      height: 125,
      backgroundColor: palette.skeleton.text,
      [breakpoints.up('sm')]: {
        maxWidth: 206,
        height: 140,
      },
      [breakpoints.up('md')]: {
        maxWidth: 'unset',
        height: 171,
      },
    },
    illustrationContainerCompact: {
      display: 'none',
      [breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    content: {
      padding: spacing(2),
      width: '100%',
      boxSizing: 'border-box',
    },
    text: {
      backgroundColor: palette.skeleton.text,
      marginBottom: spacing(2),
    },
    overline: {
      width: 100,
      backgroundColor: palette.skeleton.text,
      marginBottom: spacing(1),
    },
  }),
  { classNamePrefix: 'PathPromoCardSkeleton' }
);

const PathPromoCardSkeleton = ({
  metas = null,
  sections = [],
  actions = null,
  isCompactOnMobile = false,
}) => {
  const classes = useStyles();

  return (
    <Card
      classes={{
        root: classes.root,
        content: classes.cardContent,
      }}
      data-testid="PathPromoCardSkeleton"
    >
      <div className={classNames({ [classes.cardContentWithBorder]: isCompactOnMobile })}>
        <div className={classes.illustrationTopContent}>
          <div
            className={classNames(classes.illustrationContainer, {
              [classes.illustrationContainerCompact]: isCompactOnMobile,
            })}
            data-testid="PathPromoCardSkeletonIllustration"
          />
          <div className={classes.content}>
            <Skeleton className={classes.overline} />
            <Skeleton className={classes.text} component="p" />
            {metas && (
              <Skeleton className={classes.text} data-testid="PathPromoCardSkeletonMetas" />
            )}
          </div>
        </div>
        {sections.map((section) => (
          <div key={section.key} data-testid="PathPromoCardSkeletonSections">
            <Divider className={classes.divider} />
            <div className={classes.content}>
              <Skeleton className={classes.text} component="p" />
              <Skeleton className={classes.text} />
            </div>
          </div>
        ))}
        {actions && (
          <>
            <Divider className={classes.divider} />
            <Skeleton className={classes.text} data-testid="PathPromoCardSkeletonActions" />
          </>
        )}
      </div>
    </Card>
  );
};

export default PathPromoCardSkeleton;
